import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const invoiceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // Get all invoices
    getAllInvoices: builder.query({
      query: () => "qwikITInvoiceData/",
      providesTags: ["Invoice"],
      transformResponse: (response) => response.reverse(),
    }),

    // Get single invoice by ID
    getInvoiceById: builder.query({
      query: (id) => `qwikITInvoiceData/${id}`,
      providesTags: ["Invoice"],
    }),

    // Create new invoice
    createInvoice: builder.mutation({
      query: (data) => ({
        url: "qwikITInvoiceData/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Invoice"],
      transformResponse: (response) => {
        toast.success("Invoice saved successfully");
        return response;
      },
    }),

    // Update invoice
    updateInvoice: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `qwikITInvoiceData/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Invoice"],
      transformResponse: (response) => {
        toast.success("Invoice updated successfully");
        return response;
      },
    }),

    // Delete invoice
    deleteInvoice: builder.mutation({
      query: (id) => ({
        url: `qwikITInvoiceData/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Invoice"],
      transformResponse: (response) => {
        toast.success("Invoice deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllInvoicesQuery,
  useGetInvoiceByIdQuery,
  useCreateInvoiceMutation,
  useUpdateInvoiceMutation,
  useDeleteInvoiceMutation,
} = invoiceApi;